import React, { useState, useContext } from "react";
import "../styles/components/Nav.css";
import { useTranslation } from "react-i18next";
import { Trans } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { GlobalContext } from "../App";
function Header() {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { isLogin, setIsLogin, haveCode } = useContext(GlobalContext);
  const queryParameters = new URLSearchParams(window.location.search);
  const hardcode = "Tab2025";

  function handlelogout() {
    global.location.reload();
    localStorage.removeItem("jwt");
    localStorage.removeItem("user_data");
  }
  return (
    <nav className="gnb__nav" role="navigation">
      <div className="gnb__bar">
        <div className="gnb__bar-inner">
          <div>
            <div
              className="gnb__logo"
              onClick={() => {
                navigate(`/?code=${hardcode}`);
              }}
            >
              <span className="hidden">Samsung</span>
            </div>
          </div>
          <div className="gnb__mobile-menu">
            {/* <a
              className="gnb__cart-btn js-layer-open"
              href="https://www.samsung.com/hk/"
            >
              <span className="hidden">Cart</span>
              <svg className="icon" id="cart-bold" viewBox="0 0 96 96">
                <path d="M72.848 70.25c6.075 0 11 4.925 11 11s-4.925 11-11 11-11-4.925-11-11 4.925-11 11-11zm-35 0c6.075 0 11 4.925 11 11s-4.925 11-11 11-11-4.925-11-11c0-6.074 4.926-11 11-11zm35 7a4 4 0 10.002 8.001 4 4 0 00-.002-8.001zm-35 0a4 4 0 100 8 4 4 0 000-8zM13.892 3.75c2.287 0 4.376 1.55 5.058 3.72l.064.22 2.97 11.187h68.128a4.727 4.727 0 014.661 5.786l-.048.2-9.559 36.291c-.583 2.216-2.618 3.842-4.894 3.944l-.228.005H30.06c-2.287 0-4.377-1.55-5.06-3.72l-.063-.219-13.124-49.413-10.7.006-.004-8 12.782-.007zm72.03 23.127H24.108l8.027 30.226H77.96l7.962-30.226z"></path>
              </svg>
            </a> */}
            <div className="gnb__menu-btn" onClick={() => setIsMenuOpen(true)}>
              <span className="hidden">Open the Menu</span>
              <svg className="icon" id="menu-bold" viewBox="0 0 96 96">
                <path d="M83 70v8H13v-8h70zm0-26v8H13v-8h70zm0-26v8H13v-8h70z"></path>
              </svg>
            </div>
          </div>
          <div className={isMenuOpen ? "gnb__menu-wrap open" : "gnb__menu-wrap"}>
            <div className="gnb__depth1-container">
              <div className="gnb__main">
                <ul className={isMenuOpen ? "gnb__depth1 open" : "gnb__depth1"}>
                  <li className="gnb__depth1-menu">
                    {i18n.language == "hk" ? (
                      <a className="gnb__depth1-link" href="https://www.samsung.com/hk/offer/online-shop/">
                        <span className="gnb__depth1-link-text">
                          <Trans i18nKey="header:shop" />
                        </span>
                      </a>
                    ) : (
                      <a className="gnb__depth1-link" href="https://www.samsung.com/hk_en/offer/online-shop/">
                        <span className="gnb__depth1-link-text">
                          <Trans i18nKey="header:shop" />
                        </span>
                      </a>
                    )}
                  </li>
                  <li className="gnb__depth1-menu">
                    {i18n.language == "hk" ? (
                      <a className="gnb__depth1-link" href="https://www.samsung.com/hk/mobile/">
                        <span className="gnb__depth1-link-text">
                          <Trans i18nKey="header:mobile" />
                        </span>
                      </a>
                    ) : (
                      <a className="gnb__depth1-link" href="https://www.samsung.com/hk_en/mobile/">
                        <span className="gnb__depth1-link-text">
                          <Trans i18nKey="header:mobile" />
                        </span>
                      </a>
                    )}
                  </li>
                  <li className="gnb__depth1-menu">
                    <a className="gnb__depth1-link" href="https://www.samsung.com/hk/tvs/">
                      <span className="gnb__depth1-link-text">
                        <Trans i18nKey="header:tv" />
                      </span>
                    </a>
                  </li>
                  <li className="gnb__depth1-menu">
                    <a className="gnb__depth1-link" href="https://www.samsung.com/hk/home-appliances/">
                      <span className="gnb__depth1-link-text">
                        <Trans i18nKey="header:home" />
                      </span>
                    </a>
                  </li>
                  <li className="gnb__depth1-menu">
                    <a className="gnb__depth1-link" href="https://www.samsung.com/hk/computers/all-computers/">
                      <span className="gnb__depth1-link-text">
                        <Trans i18nKey="header:computing" />
                      </span>
                    </a>
                  </li>
                  <li className="gnb__depth1-menu">
                    <a className="gnb__depth1-link" href="https://www.samsung.com/hk/monitors/">
                      <span className="gnb__depth1-link-text">
                        <Trans i18nKey="header:displays" />
                      </span>
                    </a>
                  </li>
                  <li className="gnb__depth1-menu">
                    <a className="gnb__depth1-link" href="https://www.samsung.com/hk/mobile-accessories/">
                      <span className="gnb__depth1-link-text">
                        <Trans i18nKey="header:accessories" />
                      </span>
                    </a>
                  </li>
                  <li className="gnb__depth1-menu">
                    <a className="gnb__depth1-link" href="https://www.samsung.com/hk/smartthings/do-the-smartthings/">
                      <span className="gnb__depth1-link-text">
                        {" "}
                        <Trans i18nKey="header:smart_things" />
                      </span>
                    </a>
                  </li>
                  <li className="gnb__depth1-menu">
                    <div
                      className="gnb__depth1-link"
                      onClick={() => {
                        navigate(`/?code=${hardcode}`);
                        setIsMenuOpen(false);
                      }}
                    >
                      <span className="gnb__depth1-link-text">
                        {" "}
                        <Trans i18nKey="header:courseRegistration" />
                      </span>
                    </div>
                  </li>
                  <li className="gnb__depth1-menu">
                    <div
                      className="gnb__depth1-link"
                      onClick={() => {
                        navigate(`/enquiry`);
                        setIsMenuOpen(false);
                      }}
                    >
                      <span className="gnb__depth1-link-text">
                        <Trans i18nKey="header:registeredCourseInquiry" />
                      </span>
                    </div>
                  </li>
                </ul>
              </div>

              <div className="gnb__sub">
                <ul className={isMenuOpen ? "gnb__depth1 open" : "gnb__depth1"} role="menubar">
                  <li className="gnb__depth1-menu" role="presentation">
                    {i18n.language == "hk" ? (
                      <a className="gnb__depth1-link" href="https://www.samsung.com/hk/support/">
                        <span className="gnb__depth1-link-text">
                          <Trans i18nKey="header:support" />
                        </span>
                      </a>
                    ) : (
                      <a className="gnb__depth1-link" href="https://www.samsung.com/hk_en/support/">
                        <span className="gnb__depth1-link-text">
                          <Trans i18nKey="header:support" />
                        </span>
                      </a>
                    )}
                  </li>
                  <li className="gnb__depth1-menu">
                    {i18n.language == "hk" ? (
                      <a className="gnb__depth1-link" href="https://www.samsung.com/hk/business/">
                        <span className="gnb__depth1-link-text">
                          {" "}
                          <Trans i18nKey="header:business" />
                        </span>
                      </a>
                    ) : (
                      <a className="gnb__depth1-link" href="https://www.samsung.com/hk_en/business/">
                        <span className="gnb__depth1-link-text">
                          {" "}
                          <Trans i18nKey="header:business" />
                        </span>
                      </a>
                    )}
                  </li>
                </ul>

                <ul className="gnb__utility">
                  {isLogin ? (
                    <div className="logout-container" onClick={() => handlelogout()}>
                      <div className="logout-text">
                        {" "}
                        <Trans i18nKey="header:logout" />
                      </div>
                    </div>
                  ) : (
                    <></>
                    // <li
                    //   className="gnb__login"
                    //   onClick={() => navigate("/login")}
                    // >
                    //   <div className="gnb__login-btn">
                    //     <span className="hidden">Sign In</span>

                    //     <svg
                    //       className="icon"
                    //       id="user-bold"
                    //       viewBox="0 0 96 96"
                    //     >
                    //       <path d="M48 50c17.346 0 32 14.221 32 31.054V89c0 2.757-2.243 5-5 5H21c-2.757 0-5-2.243-5-5v-7.946C16 64.221 30.654 50 48 50zm0 8c-12.785 0-24 10.773-24 23.054V86h48v-4.946C72 68.773 60.785 58 48 58zm-.002-56c12.133 0 22.003 9.87 22.003 22.001C70 36.131 60.13 46 47.998 46c-12.13 0-21.997-9.869-21.997-21.999C26 11.87 35.867 2 47.998 2zm0 8c-7.718 0-13.997 6.281-13.997 14.001C34 31.72 40.28 38 47.998 38 55.718 38 62 31.72 62 24.001 62 16.281 55.719 10 47.998 10z"></path>
                    //     </svg>
                    //   </div>
                    //   <div className="gnb__login-layer">
                    //     <ul className="gnb__utility-menu">
                    //       <li>
                    //         <div
                    //           className="gnb__utility-link"
                    //           onClick={() => navigate("/login")}
                    //         >
                    //           <Trans i18nKey="header:login" />
                    //         </div>
                    //       </li>
                    //       <li>
                    //         <a
                    //           className="gnb__utility-link"
                    //           href="https://www.samsung.com/hk/"
                    //         >
                    //           <Trans i18nKey="header:register" />
                    //         </a>
                    //       </li>
                    //     </ul>
                    //   </div>
                    // </li>
                  )}
                  {/* <li className="gnb__cart">
                    {i18n.language == "hk" ? (
                      <a
                        href="https://shop.samsung.com/hk/cart"
                        className="gnb__cart-btn"
                      >
                        <span className="hidden">Cart</span>
                        <svg
                          className="icon"
                          id="cart-bold"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 96 96"
                        >
                          <path d="M72.848 70.25c6.075 0 11 4.925 11 11s-4.925 11-11 11-11-4.925-11-11 4.925-11 11-11zm-35 0c6.075 0 11 4.925 11 11s-4.925 11-11 11-11-4.925-11-11c0-6.074 4.926-11 11-11zm35 7a4 4 0 10.002 8.001 4 4 0 00-.002-8.001zm-35 0a4 4 0 100 8 4 4 0 000-8zM13.892 3.75c2.287 0 4.376 1.55 5.058 3.72l.064.22 2.97 11.187h68.128a4.727 4.727 0 014.661 5.786l-.048.2-9.559 36.291c-.583 2.216-2.618 3.842-4.894 3.944l-.228.005H30.06c-2.287 0-4.377-1.55-5.06-3.72l-.063-.219-13.124-49.413-10.7.006-.004-8 12.782-.007zm72.03 23.127H24.108l8.027 30.226H77.96l7.962-30.226z"></path>
                        </svg>
                      </a>
                    ) : (
                      <a
                        href="https://shop.samsung.com/hk_en/cart"
                        className="gnb__cart-btn"
                      >
                        <span className="hidden">Cart</span>
                        <svg
                          className="icon"
                          id="cart-bold"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 96 96"
                        >
                          <path d="M72.848 70.25c6.075 0 11 4.925 11 11s-4.925 11-11 11-11-4.925-11-11 4.925-11 11-11zm-35 0c6.075 0 11 4.925 11 11s-4.925 11-11 11-11-4.925-11-11c0-6.074 4.926-11 11-11zm35 7a4 4 0 10.002 8.001 4 4 0 00-.002-8.001zm-35 0a4 4 0 100 8 4 4 0 000-8zM13.892 3.75c2.287 0 4.376 1.55 5.058 3.72l.064.22 2.97 11.187h68.128a4.727 4.727 0 014.661 5.786l-.048.2-9.559 36.291c-.583 2.216-2.618 3.842-4.894 3.944l-.228.005H30.06c-2.287 0-4.377-1.55-5.06-3.72l-.063-.219-13.124-49.413-10.7.006-.004-8 12.782-.007zm72.03 23.127H24.108l8.027 30.226H77.96l7.962-30.226z"></path>
                        </svg>
                      </a>
                    )}
                  </li> */}
                </ul>

                <div className="gnb__utility-mobile">
                  {isLogin ? (
                    <ul className="gnb__utility-menu">
                      <div className="logout-container" onClick={() => handlelogout()}>
                        <div className="logout-text"> 登出</div>
                      </div>
                    </ul>
                  ) : (
                    <ul className="gnb__utility-menu">
                      {/* <li>
                        <div
                          className="gnb__utility-link"
                          onClick={() => {
                            navigate("/login");
                            setIsMenuOpen(false);
                          }}
                        >
                          <Trans i18nKey="header:login" />
                        </div>
                      </li> */}
                      <li>
                        <a className="gnb__utility-link" href="https://www.samsung.com/hk/">
                          <Trans i18nKey="header:register" />
                        </a>
                      </li>
                    </ul>
                  )}
                </div>
              </div>
            </div>

            <div className="gnb__menu-close" onClick={() => setIsMenuOpen(false)}>
              <span className="hidden">Close Menu</span>
              <svg className="icon" id="delete-bold" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 96 96">
                <path d="M79.17 11.17L48 42.34 16.83 11.17l-5.66 5.66L42.34 48 11.17 79.17l5.66 5.66L48 53.66l31.17 31.17 5.66-5.66L53.66 48l31.17-31.17z"></path>
              </svg>
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
}

export default Header;
